import { render, staticRenderFns } from "./MaintenanceMessages.vue?vue&type=template&id=59b1c764"
import script from "./MaintenanceMessages.vue?vue&type=script&lang=js"
export * from "./MaintenanceMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports